import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { RefreshCw, Phone, MessageCircle, ChevronRight } from "lucide-react";
import PageHero from "../components/PageHero";

export default function TradeInPage() {
  return (
    <div>
      <Helmet>
        <title>{"Trade-In Your Gaming Gear — GamesTrade Noida"}</title>
        <meta name="description" content="Trade in your PS5, PS4, Nintendo Switch, Xbox and more for store credit or cash. Best buyback value in Noida. Contact us for a quote." />
        <link rel="canonical" href="https://gamestrade.in/trade-in" />
      </Helmet>

      <PageHero
        eyebrow="You Play We Trade"
        title={<>Trade in <span className="text-gold">your gear</span></>}
        description="Best buyback value in Noida. Store credit or direct cash — your call."
        breadcrumbs={[{ to: "/", label: "Home" }, { label: "Trade-In" }]}
      />

      {/* Disclaimer */}
      <section className="max-w-2xl mx-auto px-6 lg:px-8 py-20 text-center">
        <div className="bg-navy-700 border border-gold/20 rounded-2xl p-10">
          <RefreshCw className="w-12 h-12 text-gold mx-auto mb-6" />
          <h2 className="text-2xl font-black uppercase tracking-tighter mb-3">
            Get a <span className="text-gold">Trade-In Quote</span>
          </h2>
          <p className="text-slate-300 text-sm leading-relaxed mb-2">
            We're currently setting up our online trade-in system. For now, reach out to us directly over call or WhatsApp — we'll give you an instant estimate for your console, controller, or games.
          </p>
          <p className="text-slate-500 text-xs mb-8">
            PS5, PS4, Nintendo Switch, Xbox, controllers, games — we buy it all.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/918287799290"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-gold text-navy-900 font-extrabold uppercase tracking-wider text-sm px-8 py-4 rounded-full hover:bg-gold-light btn-glow transition-all"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
            <a
              href="tel:+918287799290"
              className="flex items-center justify-center gap-2 border border-gold/40 text-gold font-extrabold uppercase tracking-wider text-sm px-8 py-4 rounded-full hover:bg-gold/10 transition-all"
            >
              <Phone className="w-4 h-4" /> Call Us
            </a>
          </div>

          <p className="text-slate-600 text-xs mt-6">+91 82877 99290 · Spectrum Mall, Sector 75, Noida</p>
        </div>
      </section>
    </div>
  );
}
